export default __webpack_public_path__ + "static/media/E-solid.fe1c5a7f.svg";